const http = require('../lib/httpClient');
const { getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COMMERCE_HEADER } = require('../constants');

const catalystLegalTextError = {
  code: 'CATALYST_GET_LEGAL_TEXT_ERROR',
  message: 'Unable to get legal text',
};

const endpoint = '/s/auth/v1/consent/legalText/';

async function catalystLegalTextConsent(consentId, tenantId, catalystBaseUrl = '') {
  const result = await http.get(`${catalystBaseUrl}${endpoint}${consentId}`, {
    headers: {
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId),
      'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystLegalTextError] };
  const { legalText, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  return { data: { legalText }, errors: [] };
}

module.exports = catalystLegalTextConsent;
